// extracted by mini-css-extract-plugin
export var icon = "_7n-1";
export var subtext = "_7n-0";